import api from './api';

export const leadsApi = {
  list: (params) => api.get('/api/leads', { params }),
  create: (data) => api.post('/api/leads', data),
  get: (id) => api.get(`/api/leads/${id}`),
  update: (id, data) => api.put(`/api/leads/${id}`, data),
  delete: (id) => api.delete(`/api/leads/${id}`),
  upload: (formData) => api.post('/api/leads/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getOutreach: (id) => api.get(`/api/leads/${id}/outreach`),
  getTasks: (id) => api.get(`/api/leads/${id}/tasks`),
  getNotes: (id) => api.get(`/api/leads/${id}/notes`),
  addNote: (id, content) => api.post(`/api/leads/${id}/notes`, { content }),
};
